import { ONBOARDING_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const onboardingApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getOnboardingRequests: builder.query({
            query: () => ({
                url: `${ONBOARDING_URL}/requests`,
            }),
            providesTags: ['OnboardingRequest'],
            keepUnusedDataFor: 5
        }),
        getOnboardingRequestByToken: builder.query({
            query: (token) => ({
                url: `${ONBOARDING_URL}/${token}`,
            }),
            keepUnusedDataFor: 5
        }),
        sendOnboardingRequest: builder.mutation({
            query: (data) => ({
                url: `${ONBOARDING_URL}/send`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['OnboardingRequest']
        }),
        submitOnboardingRequest: builder.mutation({
            query: ({ token, data }) => ({
                url: `${ONBOARDING_URL}/${token}/submit`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['OnboardingRequest']
        })
    })
});

export const {
    useGetOnboardingRequestsQuery,
    useGetOnboardingRequestByTokenQuery,
    useSendOnboardingRequestMutation,
    useSubmitOnboardingRequestMutation
} = onboardingApiSlice;
